import { useAuth, useOutletApi } from "@/features/authentication";
import { PermissionEnum } from "@/features/permissions";
import { usePendingCount } from "@/hooks";

// Dispatched on window after a conversion so the drawer badge drops immediately
// instead of waiting for the next poll.
export const INCOMING_PURCHASE_PAYMENTS_CHANGED_EVENT =
  "incoming-purchase-payments:changed";

/**
 * How many purchase payments are waiting for this outlet to mirror them as a
 * sales payment. Seller-scoped, so it follows the active outlet.
 *
 * Returns 0 without issuing a request when the active outlet is not a hub — a
 * retail outlet is never the seller on an internal payment.
 */
export const useIncomingPurchasePaymentsCount = () => {
  const { outlet, isHubOutlet, hasPermission } = useAuth();
  const api = useOutletApi();

  return usePendingCount({
    api,
    url: "purchase-payments/incoming",
    enabled:
      !!outlet?.id &&
      isHubOutlet &&
      hasPermission(PermissionEnum.READ_PURCHASE_PAYMENTS),
    changedEvent: INCOMING_PURCHASE_PAYMENTS_CHANGED_EVENT,
  });
};
